import type { MedplumClient } from '@medplum/core';
import type { Organization } from '@medplum/fhirtypes';

import { AI_PROMPT_KIND_TRANSFER_SUMMARY } from '@unify/fhir-model/constants';
import { resolveAiPromptText, saveAiPromptText } from '@unify/fhir-model/ai-prompt-binary';
import { resolvePracticeOrganization } from './practiceOrganization';
import { DEFAULT_AI_TRANSFER_SUMMARY_SYSTEM_PROMPT } from './clinicalSettingsConstants';

export async function resolveTransferSummaryPromptForOrganization(
  medplum: MedplumClient,
  org: Organization | null | undefined,
): Promise<string> {
  if (!org?.id) return DEFAULT_AI_TRANSFER_SUMMARY_SYSTEM_PROMPT;
  const custom = await resolveAiPromptText(
    medplum,
    AI_PROMPT_KIND_TRANSFER_SUMMARY,
    `Organization/${org.id}`,
  );
  return custom || DEFAULT_AI_TRANSFER_SUMMARY_SYSTEM_PROMPT;
}

export async function loadTransferSummaryPrompt(medplum: MedplumClient): Promise<{
  organizationId: string | null;
  prompt: string;
}> {
  const organization = await resolvePracticeOrganization(medplum);
  return {
    organizationId: organization?.id ?? null,
    prompt: await resolveTransferSummaryPromptForOrganization(medplum, organization),
  };
}

export async function saveTransferSummaryPrompt(
  medplum: MedplumClient,
  organizationId: string,
  prompt: string,
): Promise<void> {
  const trimmed = prompt.trim();
  const toSave =
    !trimmed || trimmed === DEFAULT_AI_TRANSFER_SUMMARY_SYSTEM_PROMPT.trim()
      ? undefined
      : trimmed;
  await saveAiPromptText(
    medplum,
    AI_PROMPT_KIND_TRANSFER_SUMMARY,
    `Organization/${organizationId}`,
    toSave,
  );
}
